// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangePhone_wrapper__YPkWa","greeting":"ChangePhone_greeting__5tkjB","title":"ChangePhone_title__O4J+g","text":"ChangePhone_text__7mt+J"};